import { QueryClient } from "@tanstack/react-query";

export type CatalogDomain = "product" | "paper" | "material";

const CATALOG_CACHE_ROOT_KEY = ["catalog"] as const;

export const buildCatalogCacheKey = (domain: CatalogDomain) => {
  return [...CATALOG_CACHE_ROOT_KEY, domain] as const;
};

export const invalidateCatalogCache = async (
  queryClient: QueryClient,
  domain: CatalogDomain,
) => {
  await queryClient.invalidateQueries({
    queryKey: buildCatalogCacheKey(domain),
  });
};
